<template>
  <es-loader v-if="initalizing"></es-loader>
  <div v-else class="columns is-4 is-variable">
    <div class="column is-three-quarters is-paddingless" v-if="levelParams">
      <!-- Customize Report Panel -->
      <router-view
          name="customizePanel"
          ref="customizeChild"
          v-model="searchCriteria"
          :loading="loading"
          :defaultPersonType="defaultPersonType"
          :activePersonTypes="userPersonTypes"
          :title="reportType.customizeTitle"
          :hasStatus="reportType.hasStatus"
          :hasBatchId="reportType.hasBatchId"
          :statusCode="reportType.statusCode"
          @search="onSearch();"
          @reset="onReset();"
          @specificLocationChanged="onSpecificLocationChanged($event);" />
      <!-- Report Results Panel -->
      <router-view
          name="resultsPanel"
          :loading="loading"
          :defaultPersonType="defaultPersonType"
          :results="searchResults"
          :pageSize="pageSize"
          :levelIndex="activeLevel.value"
          @goToBatch="goToBatch($event)"
          @nextLevel="nextLevel($event);"
          @previousLevel="previousLevel();"
          @generateReport="generateReport($event)"
          @updateSorter="updateSorter($event)" />
    </div>
    <div class="column is-paddingless">
      <!-- My Activity Panel -->
      <router-view
        name="myActivity"
        :reports="reports"
        :loading="loadingActivity"
        :reportTypes="pidAvailableReportTypes"
        @refresh="refreshReportActivity()">
      </router-view>
      <!-- Quick Tips Panel -->
      <div class="document-container">
        <div class="document">
          <router-view name="quickTips"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import EsLoader from '@/components/EsLoader.vue';

// mixins
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

// store
import { mapGetters, mapActions } from 'vuex';

// utils
import axios from 'axios';
import qs from 'qs';

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  components: { EsLoader },
  async created() {
    const { query, name } = this.$route;

    this.setBreadcrumbs();
    this.generateLevelParams();
    this.specificLocation = query.specificLocation ? JSON.parse(query.specificLocation) : null;
    await Promise.all([
      this.loadPersonTypes(),
      this.loadPidAvailableReportTypes(),
    ]);
    this.fetchReports();
    if (query && Object.keys(query).length) {
      const activeLevel = parseInt(query.activeLevel, 10);

      this.activeLevel = Object.values(this.levels).find(l => l.value === activeLevel);
      this.searchCriteria = {};
      Object.keys(query).forEach((key) => {
        if (query[key]) {
          if (this.listFields.includes(key)) {
            this.searchCriteria[key] = query[key].split(',');
          } else {
            this.searchCriteria[key] = query[key];
          }
        }
      });

      this.search();
    } else if (name === 'customizeAliasIdReport') {
      this.activeLevel = this.levels.specific;
    } else {
      this.activeLevel = this.levels.location;
    }
    this.initalizing = false;
  },
  data() {
    let defaultPersonType = this.$store.state.user.userPersonTypes
      .map(item => item.personType).find(a => a.status === true && a.defaultType === true);
    defaultPersonType = defaultPersonType
      || this.$store.state.user.userPersonTypes.map(item => item.personType)[0];
    return {
      initalizing: true,
      loading: false,
      loadingActivity: false,
      messages: [],
      reports: [],
      searchResults: null,
      searchCriteria: null,
      pageSize: 25,
      listFields: ['districtCodes', 'personTypeCodes', 'schoolKeys', 'statuses', 'sourceCode', 'idType'],
      levelParams: null,
      activeLevel: null,
      previousActiveLevel: null,
      specificLocation: null,
      defaultIdType: 'S',
      defaultPersonType: defaultPersonType ? defaultPersonType.code : null,
    };
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
      'loadPidAvailableReportTypes',
    ]),
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'personId' } },
        { text: 'Reports', to: { name: 'reportsmainp' } },
        { text: this.reportType.breadcrumbTitle, to: {} },
      ]);
    },
    generateLevelParams() {
      if (this.$route.query.levelParams) {
        this.levelParams = JSON.parse(this.$route.query.levelParams);
      } else {
        this.resetLevelParams();
      }
    },
    resetLevelParams() {
      this.levelParams = {};
      Object.values(this.levels).forEach((level) => {
        if (!this.levelParams[level.value]) {
          this.levelParams[level.value] = {
            page: 1,
            districtCodes: null,
            schoolKeys: null,
            id: null,
            sort: null,
          };
        }
      });
    },
    generateUrlParams(useDefaultIdType) {
      const params = {};

      Object.keys(this.searchCriteria).forEach((key) => {
        if (key === 'idType' && useDefaultIdType) {
          params[key] = this.defaultIdType;
        } else if (Array.isArray(this.searchCriteria[key])) {
          if (this.searchCriteria[key].length) {
            params[key] = this.searchCriteria[key].join(',');
          }
        } else if (this.searchCriteria[key]) {
          params[key] = this.searchCriteria[key];
        }
      });

      return params;
    },
    loadLevelSummary(level, params) {
      return axios.get(`/personid/reports/${this.reportType.apiPath}/${level}/summary`, {
        params,
        paramsSerializer(p) {
          return qs.stringify(p, { arrayFormat: 'repeat' });
        },
      });
    },
    loadLevelDetails(level, params) {
      return axios.get(`/personid/reports/${this.reportType.apiPath}/${level}/details`, {
        params: {
          ...params,
          page: this.levelParams[this.activeLevel.value].page,
          pageSize: this.pageSize,
          ...(this.levelParams[this.activeLevel.value].sort && {
            sort: JSON.stringify([this.levelParams[this.activeLevel.value].sort]),
          }),
        },
        paramsSerializer(p) {
          return qs.stringify(p, { arrayFormat: 'repeat' });
        },
      });
    },
    search() {
      this.generateLevelParams();
      this.post();
    },
    onSearch() {
      this.activeLevel = this.level;
      this.resetLevelParams();
      this.post();
    },
    onReset() {
      this.activeLevel = this.level;
      this.specificLocation = null;
      this.resetLevelParams();

      if (this.searchResults) {
        this.post();
      }
    },
    onSpecificLocationChanged($event) {
      this.specificLocation = $event;
    },
    async post(useDefaultIdType) {
      const params = this.generateUrlParams(useDefaultIdType);
      const levelParams = this.levelParams[this.activeLevel.value];

      this.loading = true;
      this.$router.replace({
        query: {
          ...params,
          levelParams: JSON.stringify(this.levelParams),
          activeLevel: this.activeLevel.value,
          page: levelParams.page,
          specificLocation: JSON.stringify(this.specificLocation),
        },
      });
      const actualParams = this.overrideSearchParams(params);

      try {
        const res = await Promise.all([
          this.loadLevelSummary(this.activeLevel.name, actualParams),
          this.loadLevelDetails(this.activeLevel.name, actualParams),
        ]);

        if (this.specificLocation && res[0].data
          && !res[0].data.districtInfo && !res[0].data.schoolInfo) {
          if (this.specificLocation.district) {
            res[0].data.districtInfo = this.specificLocation.district;
          }
          if (this.specificLocation.school) {
            res[0].data.schoolInfo = this.specificLocation.school;
          }
        }

        this.searchResults = {
          batchId: this.searchCriteria.batchId,
          id: this.searchCriteria.id,
          idType: this.searchCriteria.idType,
          summary: res[0].data,
          details: res[1].data.data,
          sorters: res[1].data.sorters,
          totalCount: res[1].data.totalCount,
        };

        this.loading = false;
      } catch (err) {
        const error = err.response.data.message;
        this.showNotification('danger', Array.isArray(error) ? error : [error]);
        this.loading = false;
        this.searchResults = null;
      }
    },
    async fetchReports() {
      this.loadingActivity = true;
      try {
        const result = await axios.get('/personid/reports/user', {
          params: {
            reportType: this.reportType.code,
            page: 1,
            pageSize: 5,
          },
        });
        this.reports = result.data.data;
        this.loadingActivity = false;
      } catch (err) {
        const error = err.response.data.message;
        this.showNotification('danger', Array.isArray(error) ? error : [error]);
        this.reports = null;
        this.loadingActivity = false;
      }
    },
    refreshReportActivity() {
      this.fetchReports();
    },
    async generateReport(type) {
      const params = this.generateUrlParams();

      if (!this.isOpen) {
        this.messages = [];
      }

      this.loadingActivity = true;
      params.fileType = type;
      params.zoneId = this.getTimeZone();
      this.messages.push('The report is being generated. Go to My Activity panel to download the report when available.');
      this.showNotification('success', this.messages);

      try {
        await axios.post(`/personid/reports/${this.reportType.apiPath}/${this.activeLevel.name}`, null, {
          params: this.overrideSearchParams(params),
        });
        await this.fetchReports();
        this.loadingActivity = false;
      } catch (err) {
        const error = err.response.data.message;
        this.showNotification('danger', Array.isArray(error) ? error : [error]);
        this.loadingActivity = false;
      }
    },
    nextLevel(item) {
      const activeLevel = parseInt(this.$route.query.activeLevel, 10) + 1;
      this.previousActiveLevel = null;
      this.activeLevel = Object.values(this.levels).find(l => l.value === activeLevel);
      this.updateLevelParams(item, true);
      this.post(true);
      this.getFocus();
    },
    previousLevel() {
      if (this.previousActiveLevel) {
        this.activeLevel = this.previousActiveLevel;
        this.previousActiveLevel = null;
      } else {
        const activeLevel = parseInt(this.$route.query.activeLevel, 10) - 1;
        this.activeLevel = Object.values(this.levels).find(l => l.value === activeLevel);
      }

      if (this.activeLevel === this.levels.location) {
        this.searchCriteria.schoolKeys = [];
      }

      if (this.searchResults.batchId && this.searchResults.details.length === 1) {
        this.updateLevelParams(this.searchResults.details[0]);
      }

      if (this.activeLevel !== this.levels.batch) {
        this.searchCriteria.batchId = null;
      }

      if (this.activeLevel !== this.levels.all) {
        this.searchCriteria.id = null;
      }

      this.post();
    },
    goToBatch(item) {
      this.previousActiveLevel = this.activeLevel;
      this.activeLevel = this.levels.batch;
      this.updateLevelParams(item);
      this.post();
      this.getFocus();
    },
    updateLevelParams(item, reset) {
      const levelParams = this.levelParams[this.activeLevel.value];

      if (reset) {
        levelParams.page = 1;
        levelParams.sort = null;
      }

      if (this.isAliasIdReport) {
        levelParams.id = item.personInfo.stateID;
        return;
      }

      levelParams.schoolKeys = item.schoolInfo ? `${item.schoolInfo.name}:${item.schoolInfo.code}` : null;
      levelParams.districtCodes = item.districtInfo ? `${item.districtInfo.name}:${item.districtInfo.code}` : null;
    },
    overrideSearchParams(params) {
      const actualParams = { ...params };
      const levelParams = this.levelParams[this.activeLevel.value];

      if (this.isAliasIdReport) {
        if (levelParams.id) {
          actualParams.id = levelParams.id;
        }

        return actualParams;
      }

      if (levelParams.schoolKeys) {
        actualParams.schoolKeys = `${levelParams.districtCodes.split(':').pop()}-${levelParams.schoolKeys.split(':').pop()}`;
      }

      if (levelParams.districtCodes) {
        actualParams.districtCodes = levelParams.districtCodes.split(':').pop();
      }

      return actualParams;
    },
    updateSorter(sorter) {
      this.levelParams[this.activeLevel.value].sort = sorter;
      this.levelParams[this.activeLevel.value].page = 1;
      this.post();
    },
    getTimeZone() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return `UTC${offset < 0 ? '+' : '-'}${(`00${Math.floor(o / 60)}`).slice(-2)}:${(`00${o % 60}`).slice(-2)}`;
    },
    getFocus() {
      // focus to the back to report link
      this.$nextTick(() => {
        if (this.$refs.customizeChild.$refs.returnLink.$el) {
          this.$refs.customizeChild.$refs.returnLink.$el.focus();
        }
      });
    },
  },
  watch: {
    $route() {
      const levelParams = this.levelParams[this.activeLevel.value];
      if (this.$route.query.page && levelParams) {
        const page = parseInt(this.$route.query.page, 10);
        if (levelParams.page !== page) {
          levelParams.page = page;
          this.post();
        }
      }
    },
  },
  computed: {
    ...mapGetters(['userPersonTypes']),
    ...mapGetters('lookups', [
      'pidAvailableReportTypes',
      'canceledRecordReportType',
      'nearMatchByLocationReportType',
      'aliasIdReportType',
      'submissionHistoryReportType',
      'noHistoryReportType',
    ]),
    level() {
      if (this.isAliasIdReport) {
        return this.searchCriteria.id ? this.levels.specific : this.levels.all;
      }

      if (!this.searchCriteria) {
        return this.levels.location;
      }
      if (this.searchCriteria.batchId) {
        return this.levels.batch;
      }
      if (this.searchCriteria.schoolKeys && this.searchCriteria.schoolKeys.length) {
        return this.levels.building;
      }
      return this.levels.location;
    },
    levels() {
      const { name } = this.$route;

      if (name === 'customizeAliasIdReport') {
        return {
          all: {
            name: 'all',
            value: 0,
          },
          specific: {
            name: 'specific',
            value: 1,
          },
        };
      }

      if (name === 'customizeNoHistoryReport') {
        return {
          location: {
            name: 'location',
            value: 0,
          },
          building: {
            name: 'building',
            value: 1,
          },
        };
      }

      return {
        location: {
          name: 'location',
          value: 0,
        },
        building: {
          name: 'building',
          value: 1,
        },
        batch: {
          name: 'batch',
          value: 2,
        },
      };
    },
    reportType() {
      const { name } = this.$route;

      if (name === 'customizeNearMatchByLocationReport') {
        return {
          hasStatus: false,
          statusCode: '',
          customizeTitle: 'Customize Report: Near Match By Location Report',
          breadcrumbTitle: 'Near Match By Location',
          apiPath: 'nearmatchByLocation',
          code: this.nearMatchByLocationReportType ? this.nearMatchByLocationReportType.code : '',
        };
      }

      if (name === 'customizeCanceledRecordReport') {
        return {
          hasStatus: true,
          statusCode: 'CAN',
          customizeTitle: 'Customize Report: Canceled Record Report',
          breadcrumbTitle: 'Canceled Record Report',
          apiPath: 'canceledRecord',
          code: this.canceledRecordReportType ? this.canceledRecordReportType.code : '',
        };
      }

      if (name === 'customizeAliasIdReport') {
        return {
          hasStatus: true,
          statusCode: '',
          customizeTitle: 'Customize Report: Alias ID Report',
          breadcrumbTitle: 'Alias ID',
          apiPath: 'aliasID',
          code: this.aliasIdReportType ? this.aliasIdReportType.code : '',
        };
      }

      if (name === 'customizeSubmissionHistoryReport') {
        return {
          hasStatus: false,
          statusCode: '',
          customizeTitle: 'Customize Report: Submission History Report',
          breadcrumbTitle: 'Submission History Report',
          apiPath: 'submissionHistory',
          code: this.submissionHistoryReportType ? this.submissionHistoryReportType.code : '',
        };
      }

      if (name === 'customizeNoHistoryReport') {
        return {
          hasStatus: false,
          hasBatchId: false,
          statusCode: '',
          customizeTitle: 'Customize Report: No History Report',
          breadcrumbTitle: 'No History Report',
          apiPath: 'noHistory',
          code: this.noHistoryReportType ? this.noHistoryReportType.code : '',
        };
      }

      return null;
    },
    isAliasIdReport() {
      return this.reportType && this.aliasIdReportType
        && this.reportType.code === this.aliasIdReportType.code;
    },
  },
};
</script>

<style lang="sass" scoped>
  .columns.is-4
    display: flex
    flex-wrap: wrap
    @media screen and (max-width: 70em)
      .column
        flex: 1 0 100%
</style>
